type Props = {
  className?: string;
  title?: string;
  height?: number;
  src?: string;
};

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3532.5111435892213!2d85.327544!3d27.7015003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb190072109b9b%3A0xb0012b338dcda4f5!2sKathmandu%20National%20Medical%20College%20%26%20Teaching%20Hospital!5e0!3m2!1sen!2snp!4v1780390038768!5m2!1sen!2snp";

export function LocationMap({
  className = "",
  title = "KNMC location on Google Maps",
  height = 320,
  src,
}: Props) {
  return (
    <div className={`overflow-hidden rounded-2xl border border-border/30 shadow-soft ${className}`}>
      <iframe
        src={src || MAP_SRC}
        title={title}
        width="100%"
        height={height}
        style={{ border: 0, display: "block" }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

